<template>
  <div class="main" ref="main">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,index) in indexMsg.banner" :key="index">
        <img :src="item.url">
      </van-swipe-item>
    </van-swipe>
    <div class="nav">
      <!-- <div v-for="(item,index) in indexMsg.channel" :key="index" @click="navMenuItemClick(item)">
        <img :src="item.iconUrl" :id="item.id">
        <p>{{item.name}}</p>
      </div> -->
      <div class="all-box-info">
        <div class="lang-box">
          <div class="item-box-info" @click="navMenuItemClick(item)" v-for="(item,index) in indexMsg.channel" :key="index">
            <img :src="item.iconUrl" :id="item.id">
            <p>{{item.name}}</p>
          </div>
        </div>

      </div>
      <!-- <van-tabs>
        <van-tab v-for="(item,index) in indexMsg.channel" :key="index">
          <template #title>

            <div @click="navMenuItemClick(item)">
              <img :src="item.iconUrl" :id="item.id">
              <p>{{item.name}}</p>
            </div>
          </template>
        </van-tab>
      </van-tabs> -->
    </div>

    <!-- 优惠券 -->
    <div class="brand" v-if="indexMsg.couponList && indexMsg.couponList.length >0">
      <panelHeader title="优惠券" tag="1" @click="RightArrowClick"></panelHeader>
      <div class="style-commen">
        <coupon @getReceive="receive" :isShowBtnRight=true v-for="(item,index) in indexMsg.couponList" :key="index" :coupinItem="item"></coupon>
      </div>

    </div>
    <!-- 品牌制造商 -->
    <div class="brand">
      <panelHeader title="品牌制造商直供" tag="2" @click="RightArrowClick"></panelHeader>
      <div class="style-commen">
        <div class="ccc" v-for="(item,index) in indexMsg.brandList" :key="index" @click="navToBrandDetail(item.id)">
          <!-- <img :src="item.picUrl"> -->
          <van-image width="100%" height="45vw" :src="item.picUrl" />
        </div>
      </div>
    </div>
    <!-- 新品首发 -->
    <div class="coupon backGround-fff">
      <panelHeader title="新品首发" tag="3" @click="RightArrowClick"></panelHeader>

      <div class="item-box">
        <van-row class="list">
          <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in indexMsg.newGoodsList" :itemInfo=itemInfo :key="index"></itemInfo>

        </van-row>
      </div>
    </div>
    <!-- 人气推荐 -->
    <div class="brand">
      <panelHeader title="人气推荐" tag="4" @click="RightArrowClick"></panelHeader>
      <div class="style-commen">

        <popular v-for="(item,index) in indexMsg.hotGoodsList" :key="index" :popularItem="item" @navDetail="navToDetail"></popular>
      </div>

    </div>
    <!-- 专题精选 -->
    <div class="special">
      <panelHeader title="专题精选" tag="5" @click="RightArrowClick"></panelHeader>
      <div class="style-commen">

        <div class="spe-item" v-for="(item,index) in indexMsg.topicList" @click="navToSpecialDetail(item.id)" :key="index">
          <img :src="item.picUrl">
          <div class="special-title-item">{{item.title}}</div>
          <div class="special-sub"><span>￥{{item.price}}</span>&nbsp;元起 &nbsp; &nbsp;| &nbsp; &nbsp;{{item.subtitle}} </div>
        </div>
      </div>

    </div>
    <!-- 平铺商品信息 -->
    <div class="floor" v-for="(item,idx) in indexMsg.floorGoodsList" :class="item.goodsList.length  ==0 ? 'showNone':''" :key="idx">
      <panelHeader :title="item.name" :tag="6+idx" @click="RightArrowClick"></panelHeader>

      <div class="item-box">

        <van-row class="list">
          <van-grid :column-num="2" :gutter="5">
            <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in item.goodsList" :key="index" :itemInfo=itemInfo></itemInfo>

          </van-grid>

        </van-row>
      </div>

    </div>

  </div>

</template>

<script>
import coupon from "@/components/coupon";
import itemInfo from "@/components/itemInfo";
import popular from "@/components/popular";
import { getIndex, couponReceive, wxGetCode } from "@/api/index";
import panelHeader from "../../components/panelHeader"; //模块顶部

import { Toast, Dialog } from "vant";

export default {
  name: "indexBase",
  components: {
    coupon,
    itemInfo,
    popular,
    panelHeader,
  },
  data() {
    return {
      indexMsg: {
        couponList: [],
      },
    };
  },
  updated() {
    this.$nextTick(function () {
      this.$el.scrollTop = this.$route.meta.scrollTop;
    });
  },
  mounted() {
    console.log(this.$store.state.base.userInfo);
    let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.indexOf("micromessenger") >= 0) {
      this.getCode();
    }

    getIndex().then((res) => {
      console.log(res);
      if (res.data.errno == 0) {
        this.indexMsg = res.data.data;
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg,
        });
      }
    });
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path == "/index") {
          window.addEventListener("scroll", this.handleScrollIndex, true);
          // this.$nextTick(() => {
          //   console.log(this.$el);
          //   console.log(this.$el.scrollTop);

          //   //   setTimeout(() => {
          //   console.log(this.$el);
          //   console.log(this.$el.scrollTop);

          //   console.log(this.$route.meta.scrollTop);

          //   if (this.$route.meta.scrollTop) {
          //     console.log(this.$el.scrollTop);
          //     this.$el.scrollTop = this.$route.meta.scrollTop;
          //     this.$refs.main.scrollTop = this.$route.meta.scrollTop;
          //     console.log(this.$el.scrollTop);
          //   }
          //   //   }, 1000);
          // });
        }
      },
      immediate: true,
    },
  },
  destroyed() {
    //移除当前页面的监听，App不能重复添加监听
    window.removeEventListener("scroll", this.handleScrollIndex);
  },

  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
      // alert(JSON.stringify(window.location.search));
      const code = this.getQueryString("code");
      if (code == null || code === "") {
        var url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe5617ba8b2e20ab1&redirect_uri=https%3a%2f%2fcruitaly.cafewallet.cn%2f%23%2findex&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect";
        window.location.href = url;
      } else {
        localStorage.setItem("code", code);
        this.getOpenId(code); //把code传给后台获取用户信息
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },

    getOpenId(code) {
      // 通过code获取 openId等用户信息，/api/user/wechat/login 为后台接口
      wxGetCode({ code: code }).then((res) => {
        console.log(res);
        if (res.data.errno != 0) return;
        this.$store.commit("SET_USERINFO", res.data.data);
        sessionStorage.setItem("Token", res.data.data.token);
      });
    },
    handleScrollIndex() {
      this.$route.meta.scrollTop = this.$el.scrollTop;
    },
    receive(id) {
      couponReceive(id).then((res) => {
        if (res.data.errno == 0) {
          Toast("领取成功");
          getIndex().then((res) => {
            console.log(res);
            if (res.status == 200) {
              this.indexMsg = res.data.data;
            }
          });
        } else if (res.data.errno == 501) {
          this.$router.push("/login");
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    navMenuItemClick(menuItem) {
      // alert(JSON.stringify(menuItem));
      this.$store.commit("SET_TYPELIST", null);
      this.$router.push({
        path: "/detail",
        query: {
          id: menuItem.id,
        },
      });
    },
    navToDetail(id) {
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id,
        },
      });
    },
    navToBrandDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/brandDetail",
        name: "品牌商详情",
        query: {
          id: id,
        },
      });
    },
    navToSpecialDetail(id) {
      this.$router.push({
        path: "/featureDetail",
        query: {
          id,
        },
      });
    },
    RightArrowClick(data) {
      switch (data) {
        case "1":
          this.$router.push({
            path: "/couponList",
          });
          break;
        case "2":
          this.$router.push({
            path: "/brandList",
          });
          break;
        case "3":
          this.$router.push({
            path: "/newProductStart",
          });
          break;
        case "4":
          this.$router.push({
            path: "/recommend",
          });
          break;
        case "5":
          this.$router.push({
            path: "/featureSelection",
          });
          break;

        default:
          this.$router.push({
            path: "/typeList",
            query: {
              id: this.indexMsg.floorGoodsList[data - 6].id,
            },
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  padding-bottom: 5rem;
  box-sizing: border-box;
  overflow-x: hidden;
  width: 100%;

  .my-swipe {
    // background: red;
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .coupon {
    margin-top: 1rem;
  }
  .backGround-fff {
    background: #fff;
  }
  .coupon-title {
    width: 100%;
    height: 4rem;
    line-height: 4rem;
    font-size: 1.6rem;
    span {
      float: right;
      margin-right: 1rem;
    }
  }
  .floor {
    background: #fff;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .showNone {
    display: none;
  }
  .floor-title {
    width: 100%;
    height: 4rem;
    line-height: 4rem;
    font-size: 1.6rem;
    span {
      float: right;
      margin-right: 1rem;
    }
  }
  .nav {
    width: 100%;
    height: 8.2rem;
    background: #fff;
    // padding: 1.2rem 0 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .all-box-info {
      height: auto;
      width: 100%;
      overflow: hidden;
      .lang-box {
        width: auto;
        display: flex;
        overflow: auto;
        height: 100%;
        .item-box-info {
          float: left;
        }
      }
    }
    // margin-top: 1.2rem;
    div {
      margin-right: 6px;
      text-align: center;
      min-width: 72px;
      .van-tabs--line .van-tabs__wrap {
        height: 100%;
      }
    }
    /deep/ .van-tabs__line {
      display: none;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
      height: 100%;
    }
    img {
      width: 3.6rem;
      height: 3.6rem;
      border-radius: 100%;
      margin-top: 1.2rem;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.6rem;
      // margin: 1.6rem 0 0;
      margin-top: 0.2rem;
    }

    .lang-box::-webkit-scrollbar {
      display: none;
    }
  }
  .brand {
    width: 100%;
    background: #fff;
    margin-top: 1.2rem;
    box-sizing: border-box;
    .ccc {
      display: inline-block;
      overflow: hidden;
      width: 50%;
      height: 0;
      padding-bottom: 50%;
    }
  }
  .special {
    width: 100%;
    background: #fff;
    margin-top: 1rem;
    .spe-item {
      margin-bottom: 1rem;
    }
    .special-title {
      width: 100%;
      height: 4rem;
      line-height: 4rem;
      font-size: 1.6rem;
      span {
        float: right;
        margin-right: 1rem;
      }
    }
    p {
      width: 96%;
      text-align: left;
      font-size: 1.6rem;
      margin: 0.5rem auto;
    }
    img {
      width: 100%;
      border-radius: 5px 5px 0 0;
      // height: 17.1rem;
    }
    .special-title-item {
      font-family: PingFangSC-Semibold;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
      text-align: left;
      box-sizing: border-box;
      padding-left: 1rem;
      margin-top: 1.5rem;
    }
    .special-sub {
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #000000;
      letter-spacing: 0;
      line-height: 1.2rem;
      text-align: left;
      margin-top: 0.9rem;

      span {
        margin-left: 1rem;
        font-family: PingFangSC-Semibold;
        font-size: 1.2rem;
        color: #d6be93;
        letter-spacing: 0;
        line-height: 1.2rem;
      }
    }
  }
}
.item-box {
  width: 100%;
  // padding-bottom: 1rem;
  padding: 0 1.6rem;
  box-sizing: border-box;
  margin-top: 0.8rem;

  .list {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 30px;
    /deep/ .van-grid {
      padding-left: 0;
    }
  }
}
.more {
  line-height: 1.7rem;
  font-size: 1.4rem;
  padding-bottom: 1rem;
}
.style-commen {
  padding: 0 1.6rem 2.4rem;
  margin-top: 0.8rem;
}
.other-box {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/index/base.vue